import { SET_DATA_DELIVERY_POINT_FOR_EDIT, SET_DATA_USER_FOR_EDIT, SET_FILTER_ACTIVE_USER, SET_FILTER_TEXT_SEARCH_USER, SET_FILTER_TYPE_USER, SET_MESSAGE_SAVE_STATE } from 'orden_express/users/usersActions.js';
import { REQUEST_RESET_STATE_USERS, RESPONSE_GET_CITIES, RESPONSE_GET_USERS, RESPONSE_SAVE_DELIVERY_POINT, RESPONSE_SAVE_USER } from 'orden_express/users/usersEpic.js';


const initialState = {
   filterTypeUser: 'Todos',
   filterActiveUser: 'Todos',
   filterTextSearchUser: '',
   responseGetUsers: {},
   responseSaveUser: {},
   dataUserForEdit: null,
   messageSaveState: 0,
   dataDeliveryPointForEdit: null,
   responseGetCities: { result: [] },
   responseSaveDeliveryPoint: {},
};

const usersReducer = (state = initialState, action) => {

   switch (action.type) {

      case REQUEST_RESET_STATE_USERS:
         return {
            ...state,
            filterTypeUser: 'Todos',
            filterActiveUser: 'Todos',
            filterTextSearchUser: '',
            responseGetUsers: {},
            responseSaveUser: {},
            dataUserForEdit: null,
            messageSaveState: 0,
            dataDeliveryPointForEdit: null,
            responseGetCities: { result: [] },
            responseSaveDeliveryPoint: {},
         };

      case SET_FILTER_TYPE_USER:
         return {
            ...state,
            filterTypeUser: action.filterTypeUser
         };
      case SET_FILTER_ACTIVE_USER:
         return {
            ...state,
            filterActiveUser: action.filterActiveUser
         };
      case SET_FILTER_TEXT_SEARCH_USER:
         return {
            ...state,
            filterTextSearchUser: action.filterTextSearchUser
         };
      case RESPONSE_GET_USERS:
         if (action.responseGetUsers.errorState) {
            return {
               ...state,
               responseGetUsers: action.responseGetUsers,
               messageSaveState: 3
            };
         } else {
            return {
               ...state,
               responseGetUsers: action.responseGetUsers,
               messageSaveState: 2
            };
         }
      case RESPONSE_SAVE_USER:
         if (action.responseSaveUser.errorState === true) {
            return {
               ...state,
               responseSaveUser: action.responseSaveUser,
               messageSaveState: 3
            };
         } else {
            return {
               ...state,
               responseSaveUser: action.responseSaveUser,
               messageSaveState: 2
            };
         }
      case SET_DATA_USER_FOR_EDIT:
         return {
            ...state,
            dataUserForEdit: action.dataUserForEdit
         };
      case SET_MESSAGE_SAVE_STATE:
         return {
            ...state,
            messageSaveState: action.messageSaveState
         };
      case RESPONSE_SAVE_DELIVERY_POINT:
         if (action.responseSaveDeliveryPoint.errorState === true) {
            return {
               ...state,
               responseSaveDeliveryPoint: action.responseSaveDeliveryPoint,
               messageSaveState: 3
            };
         } else {
            return {
               ...state,
               responseSaveDeliveryPoint: action.responseSaveDeliveryPoint,
               messageSaveState: 2
            };
         }
      case SET_DATA_DELIVERY_POINT_FOR_EDIT:
         return {
            ...state,
            dataDeliveryPointForEdit: action.dataDeliveryPointForEdit
         };
      case RESPONSE_GET_CITIES:
         return {
            ...state,
            responseGetCities: action.responseGetCities
         };

      default:
         return state;
   }
};

export default usersReducer;